import React, { useEffect, useRef, useState } from "react";
import Select, { components } from "react-select";
import plus from "../Assets/vehicle/plus.svg";
import vehicle1 from "../Assets/vehicle/Gemini_Generated_Image_nxm4ounxm4ounxm4 1.png";
import vehicle2 from "../Assets/vehicle/Gemini_Generated_Image_nxm4ounxm4ounxm4 1 (1).png";
import edit from "../Assets/Splash/edit.svg";
import "../Style/Pages/VehicleandPayment.css";
import { TbAirConditioning, TbAirConditioningDisabled } from "react-icons/tb";
import Paymenttable from "../Component/Paymenttable";
import { useSelector } from "react-redux";
import { Pencil, X } from "lucide-react";
import { LuImageUp } from "react-icons/lu";
import {
  deleteWithTokenAPI,
  getWithTokenAPI,
  postWithoutTokenAPI,
  postWithTokenAPI,
  putWithTokenAPI,
} from "../Util/Api";
import { toast } from "react-toastify";
import Swal from "sweetalert2";
import { VehicleCardSkeleton } from "../Component/Skeleton";
const VehicleandPayment = () => {
  const auth = useSelector((state) => state.auth);
  const token = auth.token;
  const adminId = auth.userId;
  const permission = auth.permission;
  const profileFileRef = useRef(null);
  const [editIndex, setEditIndex] = useState(null);
  const toggleEdit = (index) => {
    if (editIndex === index) {
      setEditIndex(null); // close edit mode
    } else {
      setEditIndex(index); // enable edit mode
    }
  };

  const categoryOptions = [
    { label: "Bike", value: "Bike" },
    { label: "Auto", value: "Auto" },
    { label: "Sedan", value: "Sedan" },
    { label: "HatchBack", value: "HatchBack" },
    { label: "SUV", value: "SUV" },
    { label: "Premium", value: "Premium" },
  ];

  const acOptions = [
    { label: "AC", value: "AC" },
    { label: "NON-AC", value: "NON-AC" },
  ];
  const [loading, setLoading] = useState(false);
  const getSeatingCapacity = (category) => {
    switch (category) {
      case "Bike":
        return 1;
      case "Auto":
        return 3;
      case "Sedan":
        return 4;
      case "HatchBack":
        return 5;
      case "SUV":
        return 7;
      case "Premium":
        return 5;
      default:
        return "";
    }
  };
  const customStyles = {
    control: (base, state) => ({
      ...base,
      minHeight: "36px",
      height: "36px",
      // width: "110px",
      minWidth: "fit-content",
      maxWidth: "160px",
      // border: "none",
      borderRadius: "14px",
      paddingLeft: "27px",
      boxShadow: state.isFocused ? "0 0 0 2px rgba(1,58,40,0.15)" : "none",
      backgroundColor: "white",
      cursor: "pointer",
      border: "1px solid var(--primary)",
    }),

    valueContainer: (base) => ({
      ...base,
      padding: "0 8px",
      height: "36px",
    }),

    singleValue: (base) => ({
      ...base,
      color: "#555",
      fontSize: "14px",
      fontWeight: "500",
      margin: 0,
      lineHeight: "36px",
      top: "0",
      transform: "none",
    }),

    placeholder: (base) => ({
      ...base,
      color: "#888",
      fontSize: "14px",
      fontWeight: "500",
    }),

    dropdownIndicator: (base) => ({
      ...base,
      color: "#666",
      padding: "0 10px",
      "&:hover": {
        color: "#333",
      },
    }),

    indicatorSeparator: () => ({
      display: "none",
    }),

    option: (base, state) => ({
      ...base,
      backgroundColor: state.isSelected
        ? "#013A28"
        : state.isFocused
          ? "#02543a53"
          : "white",
      color: state.isSelected ? "white" : "#333",
      cursor: "pointer",
      ":hover": {
        backgroundColor: state.isSelected ? "#013A28" : "#02543a53",
      },
    }),

    menu: (base) => ({
      ...base,
      borderRadius: "8px",
      boxShadow: "0 4px 12px rgba(0,0,0,0.12)",
      zIndex: 9999,
    }),

    menuList: (base) => ({
      ...base,
      padding: 0,
      maxHeight: "180px",
      // overflowY: "auto",

      "&::-webkit-scrollbar": {
        width: "6px",
      },
      "&::-webkit-scrollbar-track": {
        background: "#013a2826",
      },
      "&::-webkit-scrollbar-thumb": {
        background: "#013a2855",
        borderRadius: "3px",
      },
    }),
  };
  const [vehiclelist, setVehiclelist] = useState([]);
  useEffect(() => {
    fetchvehiclelist();
  }, [token]);
  const fetchvehiclelist = async () => {
    try {
      setLoading(true);
      const res = await getWithTokenAPI(
        token,
        `/vehicle-category/list?all=true `,
      );
      setVehiclelist(res?.data?.data);
    } catch {
      console.log("Error in fetching Limit Api");
    } finally {
      setLoading(false);
    }
  };
  function formatToINR(amount) {
    return new Intl.NumberFormat("en-IN", {
      style: "currency",
      currency: "INR",
      minimumFractionDigits: 0,
    }).format(amount);
  }

  const handleChange = (index, field, value) => {
    setVehiclelist((prev) => {
      if (!prev || !prev[index]) return prev; // 🛑 safety check

      const updated = [...prev];

      updated[index] = {
        ...updated[index],
        [field]: value,
      };

      // Extra logic for vehicleCategory
      if (field === "vehicleCategory") {
        updated[index].seatingCapacity = getSeatingCapacity(value);

        if (value === "Bike" || value === "Auto") {
          updated[index].Ac_type = "";
        } else if (!updated[index].Ac_type) {
          updated[index].Ac_type = "AC";
        }
      }

      return updated;
    });
  };

  const handleAddNew = () => {
    const newVehicle = {
      baseKm: "",
      basePrice: "",
      extraKmPrice: "",
      rushHourPrice: "",
      vehicleCategory: "",
      vehicleType: "",
      seatingCapacity: "",
      Ac_type: "AC",
      vehicleimg: "",
      isNew: true,
    };
    setEditIndex(0);
    setVehiclelist((prev) => [newVehicle, ...prev]);
  };

  const handleConfirm = async (item, index) => {
    const payload = {
      baseKm: Number(item.baseKm),
      basePrice: Number(item.basePrice),
      extraKmPrice: Number(item.extraKmPrice),
      rushHourPrice: Number(item.rushHourPrice),
      vehicleCategory: item.vehicleCategory,
      vehicleType:
        item.vehicleType ||
        (item.vehicleCategory === "Auto"
          ? "three_wheeler"
          : item.vehicleCategory === "Bike"
            ? "two_wheeler"
            : "four_wheeler"),
      seatingCapacity: Number(item.seatingCapacity),
      vehicleimg: item.vehicleimg,
      Ac_type: item.Ac_type,
      outstationPrice:Number(item.outstationPrice),
      
    };

    try {
      if (item._id) {
        await putWithTokenAPI(
          token,
          `/vehicle-category/update/${item._id}`,
          payload,
        );
        toast.success("Vehicle Updated Successfully");
        setEditIndex(null);
      } else {
        const res = await postWithTokenAPI(
          token,
          `/vehicle-category/create`,
          payload,
        );
        const updated = [...vehiclelist];
        updated[index] = res?.data?.data;
        setVehiclelist(updated);
        toast.success("Vehicle Created Successfully");
        setEditIndex(null);
      }
    } catch (err) {
      console.log(err);
      toast.error(err);
    }
  };

  const handleProfileImage = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const index = e.target.dataset.index;
    const url = await uploadImage(file);
    handleChange(Number(index), "vehicleimg", url);
  };

  const uploadImage = async (file) => {
    const formData = new FormData();
    formData.append("files", file);
    const res = await postWithoutTokenAPI(
      `/upload_image?userId=${adminId}&type=admin`,
      formData,
      true,
    );
    if (res?.data) {
      toast.success("Image Uploaded Successfully");
    } else {
      toast.error("Image Upload Failed");
    }
    return res?.data?.[0]?.fileUrl;
  };

  const confirmDelete = (item, index) => {
    Swal.fire({
      title: "Delete Vehicle?",
      text: "Are you sure you want to delete the vehicle?",
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#ba1b1b",
      cancelButtonColor: "#6c757d",
      confirmButtonText: "Yes, Delete",
    }).then((result) => {
      if (result.isConfirmed) {
        handledelete(item, index);
      }
    });
  };
  const handledelete = async (item, index) => {
    try {
      const response = await deleteWithTokenAPI(
        token,
        `/vehicle-category/delete/${item._id}`,
        { is_deleted: !item.is_deleted },
      );
      if (response.statusCode === 200) {
        toast.success("Vehicle Deleted Successfully");
        fetchvehiclelist();
      } else {
        toast.error("Vehicle not Deleted");
      }
    } catch (err) {
      toast.error(err);
    }
  };

  return (
    <div className="vp">
      <div className="vphead">
        <span>Vehicle & Payment</span>
        {permission?.prices?.create && (
          <div>
            <div className="addnewcard" onClick={handleAddNew}>
              <img src={plus} />
              Add new
            </div>
          </div>
        )}
      </div>
      {loading ? (
        <VehicleCardSkeleton />
      ) : (
        <div className="vpcard">
          {vehiclelist.map((item, index) => (
            <div className="vehiclecard" key={index}>
              <div
                className="vehicle-img-wrapper"
                onClick={() => {
                  if (editIndex !== index) return;
                  profileFileRef.current.dataset.index = index;
                  profileFileRef.current.click();
                }}
              >
                <img
                  src={item?.vehicleimg || vehicle2}
                  alt=""
                  style={{
                    cursor: editIndex === index ? "pointer" : "default",
                  }}
                ></img>
                <input
                  type="file"
                  hidden
                  ref={profileFileRef}
                  onChange={(e) => handleProfileImage(e)}
                />
                {editIndex === index && permission?.prices?.update && (
                  <div className="upload-overlay">
                    <LuImageUp size={26} />
                    <span>Upload Image</span>
                  </div>
                )}
              </div>
              {editIndex === index ? (
                <Select
                  className="dropdown"
                  value={
                    item?.vehicleCategory
                      ? categoryOptions.find(
                        (opt) => opt.value === item.vehicleCategory,
                      ) || null
                      : null
                  }
                  options={categoryOptions}
                  onChange={(selected) =>
                    handleChange(index, "vehicleCategory", selected.value)
                  }
                  isSearchable={false}
                  menuPlacement="auto"
                  menuPortalTarget={document.body}
                  menuPosition="fixed"
                  menuShouldBlockScroll={true}
                  styles={{
                    ...customStyles,
                    menuPortal: (base) => ({
                      ...base,
                      zIndex: 9999,
                    }),
                  }}
                />
              ) : (
                <input
                  className="dropdown1"
                  value={item?.vehicleCategory || ""}
                  readOnly
                />
              )}
              {/* {item?.vehicleCategory !== "Bike" &&
              item?.vehicleCategory !== "Auto" && (
                <div
                  onClick={() => {
                    if (editIndex !== index) return;

                    const newValue = item?.Ac_type === "AC" ? "NON-AC" : "AC";

                    handleChange(index, "Ac_type", newValue);
                  }}
                  style={{
                    cursor: editIndex === index ? "pointer" : "default",
                  }}
                >
                  {item?.Ac_type === "AC" ? (
                    <TbAirConditioning className="ac" title="AC" />
                  ) : (
                    <TbAirConditioningDisabled className="ac" title="Non-Ac" />
                  )}
                </div>
                )} */}

              {item?.vehicleCategory !== "Bike" &&
                item?.vehicleCategory !== "Auto" && (
                  <div style={{ backgroundColor: "white" }}>
                    <div
                      className="ac"
                      style={{ color: "white", top: "10%", fontWeight: "600" }}
                    >
                      {" "}
                      {item?.Ac_type === "AC" ? "AC" : "NON-AC"}
                    </div>
                    <div
                      onClick={() => {
                        if (editIndex !== index) return;

                        const newValue =
                          item?.Ac_type === "AC" ? "NON-AC" : "AC";

                        handleChange(index, "Ac_type", newValue);
                      }}
                      style={{
                        cursor: editIndex === index ? "pointer" : "not-allowed",
                        opacity: editIndex === index ? 1 : 0.6,
                      }}
                      className={` ac ac-toggle ${item?.Ac_type === "AC" ? "ac-on" : "ac-off"
                        }`}
                    >
                      <span className="round"></span>
                    </div>
                  </div>
                )}
              <div className="vehiclecarddetails">
                {permission?.prices?.update && (
                  <div className="edit" onClick={() => toggleEdit(index)}>
                    {editIndex === index ? (
                      <X size={20} className="cancel" />
                    ) : (
                      <Pencil size={20} />
                    )}
                  </div>
                )}
                <span>
                  Base Km:
                  <b>
                    <input
                      type="text"
                      value={item?.baseKm}
                      disabled={editIndex !== index}
                      onChange={(e) =>
                        handleChange(index, "baseKm", e.target.value)
                      }
                    ></input>
                  </b>
                  km
                </span>
                <span>
                  Base Price:
                  <b>
                    ₹
                    <input
                      type="text"
                      value={item?.basePrice}
                      disabled={editIndex !== index}
                      onChange={(e) =>
                        handleChange(index, "basePrice", e.target.value)
                      }
                    ></input>
                  </b>
                </span>
                <span>
                  Extra Km:
                  <b>
                    ₹
                    <input
                      type="text"
                      value={item?.extraKmPrice}
                      disabled={editIndex !== index}
                      onChange={(e) =>
                        handleChange(index, "extraKmPrice", e.target.value)
                      }
                    ></input>
                  </b>
                  / km
                </span>
                <span>
                  Rush hours:
                  <b>
                    ₹
                    <input
                      type="text"
                      value={item?.rushHourPrice}
                      disabled={editIndex !== index}
                      onChange={(e) =>
                        handleChange(index, "rushHourPrice", e.target.value)
                      }
                    ></input>
                  </b>
                  / km
                </span>

                <span>
                  Outstation:
                  <b>
                    ₹
                    <input
                      type="text"
                      value={item?.outstationPrice}
                      disabled={editIndex !== index}
                      onChange={(e) =>
                        handleChange(index, "outstationPrice", e.target.value)
                      }
                    />
                  </b>
                  / km
                </span>

                <div
                  style={{
                    width: "90%",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  {item?._id && editIndex === index && (
                    <button
                      type="submit"
                      onClick={() => confirmDelete(item, index)}
                      style={{
                        backgroundColor: "#b02732",
                        color: "white",
                        border: "1px solid white",
                        width: "45%",
                      }}
                    >
                      Delete
                    </button>
                  )}
                  {editIndex === index && (
                    <button
                      type="submit"
                      onClick={() => handleConfirm(item, index)}
                      style={{ width: item?._id ? `45%` : `90%` }}
                    >
                      {item?._id ? "Confirm" : "Create"}
                    </button>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
      <div className="vptable">
        <Paymenttable type={"driver"} />
      </div>
    </div>
  );
};

export default VehicleandPayment;
